import { render } from "./EmissionCoveragePage.vue?vue&type=template&id=c27074de&scoped=true"
import script from "./EmissionCoveragePage.vue?vue&type=script&lang=js"
export * from "./EmissionCoveragePage.vue?vue&type=script&lang=js"

import "./EmissionCoveragePage.vue?vue&type=style&index=0&id=c27074de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27074de"]])

export default __exports__